import { get, post, put } from "../services/HttpService";


export class Report {
    constructor(reportObject = {}) {
        this.set(reportObject);
    };

    static validations = {

    };

    /**
     * @memberof Report
     * @type API
     * @returns Promise
     */
    static list = (queryData = {}, config = {}) => {
        return get(`v1/internal/reports/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof Report
     * @type API
     * @returns Promise
     */
        static list_v2 = (queryData = {}, config = {}) => {
            return get(`v2/internal/reports/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
        };

    /**
     * @memberof Report
     * @type API
     * @returns Promise
     */
    download = (queryData = {}, config = {}) => {
        return post(`v1/internal/reports/download/${this.id}/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof Report
     * @type Getter Method
     * @takes void
     * @returns Report Params
     */
    get = () => {
        return {
            id: this.id,
            name: this.name,
            report_type: this.report_type,
            report_type_label: this.report_type_label,
            duration_start_date: this.duration_start_date,
            duration_end_date: this.duration_end_date,
            duration_type: this.duration_type
        }
    };

    /**
     * @memberof Report
     * @type Setter Method
     * @takes Report Params
     * @returns void
     */
    set = (values) => {
        Object.keys(values).forEach(x => this[x] = values[x]);
    };
}